<template>
  <Toast
    position="top-center"
    class="z-[1004]"
    group="sessionExpired"
  >
    <template #container="{ message, closeCallback }">
      <div class="flex flex-col items-start flex-auto p-4">
        <div class="flex items-center gap-2">
          <span class="icon icon-circle-warning"></span>
          
          <span class="font-medium">{{ message.title }}</span>
        </div>

        <div class="my-4">
          {{ message.summary }}
        </div>

        <Button
          size="small"
          :label="$t('signIn')"
          @click="($e) => {
            $e.preventDefault()
            closeCallback()
            
            drawerOptions.entry = {
              typeId: 'entry',
              componentId: 'WidgetsSystemEntry',
              viewType: 'secondary',
              header: $t('signIn'),
              buttons: false,
              typeForm: 'login',
              redirectLink: false,
              returnData: () => { }
            }
          }"
        ></Button>
      </div>
    </template>
  </Toast>
</template>

<script setup>
/*
* In expiredModal() Funct
*/
const { drawerOptions } = usePopups()
</script>